export const newsletter = {
  newsletter: {
    title: 'Almost there!',
    subTitle: 'Check your inbox. We have sent you an <br/> email to confirm your email address.',
    steps: {
      stepOne: {
        title: '1. Open email',
        info: 'Please check your email inbox.',
      },
      stepTwo: {
        title: '2. Confirm registration',
        info: 'Click the link in the email to confirm your registration.',
      },
      stepThree: {
        title: '3. Enjoy exclusive benefits',
        info: 'As a newsletter reader, you benefit from exclusive advance information, attractive offers & practical tips for family life.',
      },
    },
    unsubscribeSuccess: 'You have been successfully unsubscribed from our newsletter.',
    noEmail: 'No email received?',
    noEmailDescription:
      "It may be that the email ended up in your spam folder. <br /> It's best to check all folders or contact: ",
    habaServiceMailAddress: '<u>customerservice@haba.de</u>',
    tips: 'Our tip',
    tipsDescription:
      'Add the sender address of our newsletter to your personal address book right away to receive the newsletters correctly. <br /><br /> Has an error crept into your email address? <br /> Then you can enter it again.',
  },
};
